import preset from "../preset";

export type fa_size = 'xs' | 'sm' | 'lg' | '2x' | '3x' | '5x' | '7x' | '10x';

export const mapFaSize = preset.xclasses('faSize');
